module.exports = __webpack_public_path__ + "7f16d4c20722da1ce3221a069b4781c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/petsmart_2023_chart.png
// module id = 1715
// module chunks = 0